webpackJsonp([41434416953402],{

/***/ 1411:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"CreditReasonInput","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"isActive","type":{"kind":"SCALAR","name":"Boolean","ofType":null}},{"defaultValue":null,"description":null,"name":"name","type":{"kind":"SCALAR","name":"String","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---input-object-credit-reason-input-96dce56d9b8581fd6a24.js